export default "__VITE_ASSET__kFpSu4mU__"